import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb'

@Component({
  selector: 'app-sub-layout',
  standalone: true,
  imports: [RouterOutlet, NzBreadCrumbModule],
  templateUrl: './sub-layout.component.html',
})
export class SubLayoutComponent {}
